export function parseSseBuffer(buffer) {
  const parts = buffer.split("\n\n");
  const remainder = parts.pop() || "";
  const events = parts
    .filter((p) => p.startsWith("data: "))
    .map((p) => JSON.parse(p.slice(6)));
  return { events, remainder };
}

export async function streamRagChat({
  apiUrl,
  token,
  equipoId,
  message,
  sessionId,
  onSessionId,
  onDelta,
  onDone,
  signal,
}) {
  const response = await fetch(`${apiUrl}/ia/rag/chat/${equipoId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ message, sessionId }),
    signal,
  });

  if (!response.ok || !response.body) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "Error al conectar con el chat");
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let receivedDone = false;

  const processEvents = (events) => {
    for (const event of events) {
      if (event.sessionId) onSessionId?.(event.sessionId);
      if (event.delta) onDelta?.(event.delta);
      if (event.done) {
        receivedDone = true;
        onDone?.(event.citations || []);
      }
      if (event.error) throw new Error(event.error);
    }
  };

  const safeParse = (text) => {
    try {
      return parseSseBuffer(text);
    } catch {
      throw new Error("Error al interpretar la respuesta del chat");
    }
  };

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const parsed = safeParse(buffer);
      buffer = parsed.remainder;
      processEvents(parsed.events);
    }

    if (buffer.trim()) {
      const parsed = safeParse(`${buffer}\n\n`);
      processEvents(parsed.events);
    }

    if (!receivedDone) {
      throw new Error("La conexión con el chat se interrumpió antes de completarse");
    }
  } finally {
    try {
      reader.releaseLock();
    } catch {
      // ya liberado o el stream ya terminó; no es un error real
    }
  }
}
